import rung from "rung/src/rung";
import Tiles from "../tiles";

const rng = rung();

const prefab = [
  "$$$$$>$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$",
  "$$$$$.$$$$..$$$$$$$.$$$.$$$..$..$$....$....$..===========.$...$.....$......$",
  "$$$....$...$...$$....$....$....$.....$.$......=&%&%&%&%&=....$..$$.....$...$",
  "$$$.............$.....$......$..........$.....=&%&%&%&%&=........$.........$",
  "$$........$.......................$...........=&%&%&%&%&=.....$....$...$...$",
  "$$.$........$.........$........*..*...$.......=&%&%&%&%&=...$....$$.$......$",
  "$$$.....$$...........$$$$.......*.*.*.........=&%&%&%&%&=..$.$..$.$...$$...$",
  "$$$$$...$.......$$$.$$$$$$........**..........=&%&%&%&%&=.$...$........$...$",
  "$$$$$$$....$.$$$$$$$$$$$$$$...................=======&%&=$...........$.....$",
  "$$$$$$$$$$$$$.$$$$$$$$$$$$$$$======:===========&%&%&%&%&=$....$...$$..$....$",
  "$$$$$$$$$$$$$..$$$$$$$$$$$$$$=%&%&%&%&%&%&%&%&%&%&%&%&%&=...$$.........$...$",
  "$$$$$$$$$$$$$.$$$$.$$$$$$$$$$=%&%&%&%&%&%&%&%&=&%&%&%&%&=.......$..$$.$....$",
  "$$$$$$$$$$$$$...$...$$$$$$$$$=%&%&%&%&%&%&%&%&=&%&%&%&%&=$.....$$$.....$$..$",
  "$$$$$$$$$$$$$.$.$.....$$$$$$$======================:=====$$........$$.....$$",
  "$$$$$$.$$$$$......$.....$$$$...........................$$$.$.$....$......$$$",
  "$$$$$...$$$.....$........$...............................................$$$",
  "$$$$.....$.....$.....$....................................$$....$..$....$$$$",
  "$$$....$.....$.....................#####################...$$...$.$..$$$$$$$",
  "$$..........$.....$................#AAAAAAAAAAAAAAAAAAA#..$$$.$$........$$$$",
  "$..................................#------------------C#$.$$........$$$$$$$$",
  "$.....$.........$..................+-----------AAAAAA-C#$..$$$.$.$$$$$$$$$$$",
  "$$.................................#------------------C#....$.....$$$$$$$$$$",
  "$.......##################+######..#AAAAAAAAAAAAAAAAAAA#...........$$$$$$$$$",
  "$.......#AAAUAAAAAAAAAAA-----AAA#..#####################.....$$......$$$$$$$",
  "$.......#A---------------------A#..=%&%&%&%&%&%&%&%&%&%=..$........$....$$$$",
  "$......$#A---------------------A#..=%&%&%&%&%&%&%&%&%&%=..$.....$$....$..$$$",
  "$.....$$#A---------------------A#..=%&%&%&%&%&%&%&%&%&%=.........$$.......$$",
  "$....$$$#A---------------------A#..=%&%&%&%&%&%&%&%&%&%=........$$..$......$",
  "$....$.$#A---------------------A#..=====================$..............$$.$$",
  "$...$$.$#A---------------AAAAA-A#$..................$$$$$...$$....$.....$$$$",
  "$.......#C---------------AAAAA-A#$$....$.........................$$...$$$$$$",
  "$$....$$#C⍦--------------------A#$$$..$$.$..$..$$........$$$...$....$$$$$$$$",
  "$$$..$$$#CCCAAAAAAAAAAAAAAAAAAAA#$$$$$$$$.$$.$$$$$........$..$$$$.$..$$$$$$$",
  "$$$$$$$$#########################$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$",
];

const farmletForest = [
  Tiles.Trees1,
  Tiles.Trees2,
  Tiles.Trees3
];

const farmletField = [
  Tiles.Field1,
  Tiles.Field2,
  Tiles.Field3
]

function generateFarmlet() {
  const terrain = [];
  const tiles = [];

  for (let y=0; y < prefab.length; y++) {
    terrain[y] = prefab[y].split("");
  }

  for (let y=0; y < prefab.length; y++) {
    tiles[y] = terrain[y].map(cell => {
      switch (cell) {
        case ".": return farmletField[rng.integer(0,3)];
        case "$": return farmletForest[rng.integer(0,3)];
        case "=": return Tiles.Fence;
        case "&": return Tiles.Furrow;
        case "%": return Tiles.Cabbages;
        case "#": return Tiles.House;
        case "-": return Tiles.Floor;
        case "+": return Tiles.ClosedCottageDoor;
        case "*": return Tiles.Swale;
        case ">": return Tiles.ForestPath;
        case "⍦": return Tiles.CandleForYourFather;
        case "U": return Tiles.Emblem;
        case "C": return Tiles.Chimney;
        case "A": return Tiles.Wall;
        default: return Tiles.Field1;
      }
    });
  }

  return {
    tiles,
    portals: {
      start: { y: 28, x: 13 },
      exit: { y: 0, x: 5 }
    },
    features: {}
  }
}

export {
  generateFarmlet
}
